export default "__VITE_PUBLIC_ASSET__ba4c91f9__"